export { DynamicMapView as default } from "./DynamicMapView";
